import TKBasketButton, { BasketActionTypes } from '@tk/components/tk.basket.button';
import { BasketAction } from '@tk/utilities/tk.basket.action';
import { NotificationType, sendNotification } from '@tk/utilities/tk.notification';
const NAMES = ['Anna', 'Luca', 'Mia', 'Noah', 'Lea', 'Elias', 'Sofia', 'Leon', 'Emma', 'Jonas'];
const FALLBACK_MESSAGE = 'Das hast du gut gemacht %1';
const MIN_QUANTITY = 1;

/**
 * Extends the TK basket button with
 * - an additional success message containing a random name after an article was added to the basket
 * - a minimum quantity of 1 when adding articles (0 or empty is not possible)
 */
export default class ProjectBasketButton extends TKBasketButton {
    connectedCallback(): void {
        super.connectedCallback();
        if (this.action !== BasketActionTypes.ADD) return;
        this.counters?.forEach((counter) => {
            if (Number(counter.min) < MIN_QUANTITY) counter.min = String(MIN_QUANTITY);
            ProjectBasketButton.ensureMinQuantity(counter);
            const onChange = () => ProjectBasketButton.ensureMinQuantity(counter);
            this.pushListener({ event: 'change', element: counter, action: onChange });
        });
    }

    handleBasketClick() {
        if (this.action === BasketActionTypes.ADD) {
            this.counters?.forEach((counter) => ProjectBasketButton.ensureMinQuantity(counter));
        }
        super.handleBasketClick();
    }

    static ensureMinQuantity(counter: HTMLInputElement) {
        // Hidden dimensions are not sent, so they must not be changed
        if (counter.closest<HTMLElement>('[data-tk-dimension]')?.hidden) return;
        const value = Number(counter.value);
        const min = Math.max(Number(counter.min) || MIN_QUANTITY, MIN_QUANTITY);
        if (Number.isNaN(value) || value < min) counter.value = String(min);
    }

    registerBasketListener() {
        super.registerBasketListener();
        this.basketAction.subscribe((event) => {
            if (event.action !== BasketAction.REFRESHED_LIST) return;
            if (!event.data?.success || event.data.action !== 'added') return;
            ProjectBasketButton.sendSuccessMessage();
        });
    }

    static sendSuccessMessage() {
        // Text comes from the text library (data attribute), the constant is only a fallback
        const wrapper = document.querySelector<HTMLElement>('[data-tk-basket-success-message]');
        const message = wrapper?.dataset.tkBasketSuccessMessage || FALLBACK_MESSAGE;
        const name = NAMES[Math.floor(Math.random() * NAMES.length)];
        sendNotification(NotificationType.SUCCESS, message.replace('%1', name));
    }
}
